// MY > 설정 > 버전 5회 탭으로 개발자 모드 켠 뒤 "디버그 모드" ON 시,
// 또는 URL ?debug=<REACT_APP_LOG_ACCESS_KEY> 로 접속 시 광고 에러 패널 표시.
import { useState, useCallback } from 'react';
import { hasLogAccess } from '../utils/environment';

const AdDebugPanel = ({ info, onClear }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    if (!info || typeof navigator?.clipboard?.writeText !== 'function') return;
    const { phase, message, code, status, details, timestamp } = info;
    const timeStr = new Date(timestamp).toLocaleTimeString();
    const copyText = [
      `[광고 디버그] ${timeStr}`,
      `단계: ${phase === 'verify' ? '광고 시청 후 검증' : '광고 표시'}`,
      `메시지: ${message || '-'}`,
      status != null ? `HTTP 상태: ${status}` : '',
      code != null ? `코드: ${code}` : '',
      details != null ? `상세: ${typeof details === 'object' ? JSON.stringify(details) : String(details)}` : ''
    ].filter(Boolean).join('\n');
    navigator.clipboard.writeText(copyText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {});
  }, [info]);

  if (!hasLogAccess() || !info) return null;

  const { phase, message, code, status, details, timestamp } = info;
  const timeStr = new Date(timestamp).toLocaleTimeString();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        maxHeight: '40vh',
        overflow: 'auto',
        background: 'rgba(0,0,0,0.92)',
        color: '#eee',
        padding: '12px 16px',
        fontSize: '12px',
        fontFamily: 'monospace',
        zIndex: 99999,
        borderTop: '2px solid #f44336',
        boxSizing: 'border-box'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, gap: 8 }}>
        <strong style={{ color: '#f44336' }}>[광고 디버그] {timeStr}</strong>
        <div style={{ display: 'flex', gap: 6 }}>
          <button
            type="button"
            onClick={handleCopy}
            style={{
              padding: '4px 10px',
              background: copied ? '#2E7D32' : '#333',
              color: '#fff',
              border: '1px solid #666',
              borderRadius: 4,
              fontSize: 12,
              cursor: 'pointer'
            }}
          >
            {copied ? '복사됨' : '복사'}
          </button>
          <button
            type="button"
            onClick={onClear}
            style={{
              padding: '4px 10px',
              background: '#333',
              color: '#fff',
              border: '1px solid #666',
              borderRadius: 4,
              fontSize: 12,
              cursor: 'pointer'
            }}
          >
            닫기
          </button>
        </div>
      </div>
      <div style={{ marginBottom: 4 }}><strong>단계:</strong> {phase === 'verify' ? '광고 시청 후 검증' : '광고 표시'}</div>
      <div style={{ marginBottom: 4 }}><strong>메시지:</strong> {message || '-'}</div>
      {status != null && <div style={{ marginBottom: 4 }}><strong>HTTP 상태:</strong> {status}</div>}
      {code != null && <div style={{ marginBottom: 4 }}><strong>코드:</strong> {code}</div>}
      {details != null && (
        <div style={{ marginBottom: 4 }}>
          <strong>상세:</strong>
          <pre style={{ margin: '4px 0 0', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {typeof details === 'object' ? JSON.stringify(details, null, 2) : String(details)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default AdDebugPanel;
